<script>
    export let classNames = "";
</script>

<div class="lds-ring {classNames}">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>

<style>
    /* waiting spinner */
    .lds-ring {
        width: 120px;
        height: 120px;
        margin: 32px auto;
    }

    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 120px;
        height: 120px;
        margin: 6px;
        border: 16px solid;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: var(--primaryColor) transparent transparent transparent;
    }

    .lds-ring.big div {
        width: 160px;
        height: 160px;
    }

    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }

    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }

    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
